import React, { useState } from "react";
import SimpleLabelValue from "../../SimpleLabelValue";
import "./style.scss";
import { useTripsStepper } from "../StepperContext";
import axios from "axios";

const PayForm = ({ total, id }) => {
  const { invoice } = useTripsStepper();
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    const type = "pTrip";

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BaseUrl}/paypal/create-payment`,
        {
          amount: total,
          return_url: `https://eventscons.com/success/${type}/${id}/0`,
          cancel_url: `https://eventscons.com/failed`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // ✅ IMPORTANT FIX
      const approvalUrl = response.data.approval_url;

      if (!approvalUrl) {
        throw new Error("Approval URL not received from PayPal");
      }

      // ✅ Redirect directly (sandbox / live auto handled)
      window.location.href = approvalUrl;

    } catch (error) {
      console.error("❌ Payment Error:", error.response?.data || error);
      alert("Payment failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pay-form-container">
      {invoice.length > 0 ? (
        <ul className="invoice-list">
          {invoice.map((inv, index) => (
            <li key={index} className="invoice-item">
              <h3>Participant ID: {inv.participant_id}</h3>
              <SimpleLabelValue label="Base Price" value={inv.base_price} />
              <SimpleLabelValue label="Options Price" value={inv.options_price} />
              <SimpleLabelValue label="Total Price (USD)" value={inv.total_price} />
            </li>
          ))}
        </ul>
      ) : (
        <p>No invoices available.</p>
      )}

      <div className="actions-section">
        <button
          className="next-button"
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? "Redirecting to PayPal..." : "Pay Now"}
        </button>
      </div>
    </div>
  );
};

export default PayForm;